// extracted by mini-css-extract-plugin
module.exports = {"timeframeContainer":"Header_timeframeContainer__w3gFO"};